import { where } from "firebase/firestore";
import { Collection, WhereField } from '../../shared/constants';
import { deleteDoc, getAllDocsByParkId, getAllDocsByQueries, getAllDocsByRevendaId, getDocByQueries, updateDoc } from './collectionBaseWorker';

export const getAllDevicesByParkId = async ({ estacionamentoId }) => {
    const docs = await getAllDocsByParkId({ collection: Collection.DEVICES, estacionamentoId: estacionamentoId })
    return docs
}

export const getDeviceByIdAndParkId = async ({ id, estacionamentoId }) => {
    return await getDocByQueries({
        collection: Collection.DEVICES,
        queries: [
            where(WhereField.ID, '==', id),
            where(WhereField.PARKID, '==', estacionamentoId)
        ]
    })
}

export const getAllDevicesByRevendaId = async ({ revendaId }) => {
    const docs = await getAllDocsByRevendaId({ collection: Collection.DEVICES, revendaId: revendaId })
    return docs
}

export const getAllDevicesByRevendasIds = async ({ ids }) => {
    const docs = await getAllDocsByQueries(
        {
            collection: Collection.DEVICES,
            queries: [
                where(WhereField.REVENDAID, 'in', ids)
            ]
        }
    )
    return docs
}

export const updateDevice = async ({ id, data }) => {
    data.lastUpdate = new Date()
    await updateDoc({ collection: Collection.DEVICES, id: id, data: data })
}

export const deleteDevice = async ({ id }) => {
    await deleteDoc({ collection: Collection.DEVICES, id: id })
}
